import React, { useEffect, useState, useCallback } from "react";
import { PointerSensor, useSensor, useSensors } from "@dnd-kit/core";
import * as services from "../services/saleng";
import { getContrastColor } from "../utils/fontColor";

export default function App() {
  const [allProducts, setAllProducts] = useState([]);
  const [box1, setBox1] = useState([]);
  const [box2, setBox2] = useState([]);
  const [filteredBox1, setFilteredBox1] = useState([]);
  const [selectedCard, setSelectedCard] = useState(null);
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);

  const sensors = useSensors(
    useSensor(PointerSensor, { activationConstraint: { distance: 5 } })
  );

  // โหลดสินค้า + layout
  const fetchData = useCallback(async () => {
    try {
      const productsRes = await services.getProductsBranch(true);
      const products = productsRes?.data?.data ?? [];

      const productMap = {};
      products.forEach((item) => {
        productMap[item.id] = {
          productId: item.id,
          title: item.title,
          categoryId: item.category?.id ?? null,
          categoryName: item.category?.name ?? "ไม่ระบุ",
          color: item.subCategory?.color ?? "royalblue",
        };
      });

      setAllProducts(Object.values(productMap));

      const userId = 1;
      let box1Arr = [];
      let box2Arr = [];

      try {
        const layoutRes = await services.getUserLayout(userId);
        const layout = layoutRes?.data ?? [];

        if (layout.length > 0) {
          layout.forEach((l) => {
            const card = productMap[l.productId];
            if (!card) return;

            if (l.box === "box1")
              box1Arr.push({ ...card, position: l.position });
            if (l.box === "box2")
              box2Arr.push({ ...card, position: l.position });
          });

          setBox1(box1Arr.sort((a, b) => a.position - b.position));
          setBox2(box2Arr.sort((a, b) => a.position - b.position));
        } else {
          setBox1(Object.values(productMap));
        }
      } catch (err) {
        console.error("Cannot load user layout:", err);
        setBox1(Object.values(productMap));
      }
      const allProductsArray = Object.values(productMap);

      // สร้าง array ของ unique categories พร้อม order
      const uniqueCategories = [];
      
      allProductsArray.forEach((p) => {
        if (!p.categoryId) return;
        // หาตัว category ใน products ดั้งเดิม
        const originalProduct = products.find(prod => prod.id === p.productId);
        const cat = originalProduct.category;
        if (!uniqueCategories.some(c => c.id === p.categoryId)) {
          uniqueCategories.push({
            id: p.categoryId,
            name: p.categoryName,
            order: Number(cat?.order) || 0,
          });
        }
      });
      
      // เรียงตาม order
      uniqueCategories.sort((a, b) => a.order - b.order);
      
      setCategories(uniqueCategories);
      
      // default selectedCategory
      if (uniqueCategories.length > 0) setSelectedCategory(uniqueCategories[0].id);
      
    } catch (err) {
      console.error(err);
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  useEffect(() => {
    if (categories.length > 0 && !selectedCategory) {
      setSelectedCategory(categories[0].id);
    }
  }, [categories, selectedCategory]);

  useEffect(() => {
    if (!selectedCategory) {
      setFilteredBox1(box1.filter(
        (i) => !box2.some((b) => b.productId === i.productId)
      ));
    } else {
      setFilteredBox1(
        box1.filter(
          (i) => i.categoryId === selectedCategory && !box2.some((b) => b.productId === i.productId)
        )
      );
    }
  }, [selectedCategory, box1, box2]);
  const saveLayoutToAPI = async () => {
    try {
      const layout = [
        ...box1.map((item, index) => ({
          productId: item.productId,
          box: "box1",
          position: index,
        })),
        ...box2.map((item, index) => ({
          productId: item.productId,
          box: "box2",
          position: index,
        })),
      ];

      await services.saveLayout({ userId: 1, layouts: layout });
      alert("บันทึกเรียบร้อยแล้ว!");
    } catch (err) {
      console.error(err);
      alert("เกิดข้อผิดพลาดในการบันทึก");
    }
  };

  // Drag & Drop cross-container
  const handleDragEnd = ({ active, over }) => {
    if (!over) return;
    const activeId = active.id;

    const fromBox = box1.some((i) => i.productId === activeId)
      ? "box1"
      : "box2";
    const movingItem =
      fromBox === "box1"
        ? box1.find((i) => i.productId === activeId)
        : box2.find((i) => i.productId === activeId);

    if (over.id === "box1" && fromBox !== "box1") {
      setBox2(box2.filter((i) => i.productId !== activeId));
      setBox1([...box1, movingItem]);
      return;
    }
    if (over.id === "box2" && fromBox !== "box2") {
      setBox1(box1.filter((i) => i.productId !== activeId));
      setBox2([...box2, movingItem]);
      return;
    }

    const items = fromBox === "box1" ? box1 : box2;
    const setter = fromBox === "box1" ? setBox1 : setBox2;
    const indexActive = items.findIndex((i) => i.productId === activeId);
    const indexOver = items.findIndex((i) => i.productId === over.id);

    if (indexActive !== -1 && indexOver !== -1) {
      const newItems = [...items];
      [newItems[indexActive], newItems[indexOver]] = [
        newItems[indexOver],
        newItems[indexActive],
      ];
      setter(newItems);
    }
  };

  // swap card click
  const handleCardClick = (id, boxName) => {
    if (!selectedCard) {
      setSelectedCard({ id, boxName });
      return;
    }
    const { id: selectedId, boxName: selectedBox } = selectedCard;
    if (id === selectedId && boxName === selectedBox) {
      setSelectedCard(null);
      return;
    }

    if (boxName === selectedBox) {
      const setter = boxName === "box1" ? setBox1 : setBox2;
      const items = boxName === "box1" ? box1 : box2;
      const newItems = [...items];
      const i1 = newItems.findIndex((i) => i.productId === id);
      const i2 = newItems.findIndex((i) => i.productId === selectedId);
      [newItems[i1], newItems[i2]] = [newItems[i2], newItems[i1]];
      setter(newItems);
    } else {
      const fromSetter = selectedBox === "box1" ? setBox1 : setBox2;
      const toSetter = boxName === "box1" ? setBox1 : setBox2;
      const fromItems = selectedBox === "box1" ? [...box1] : [...box2];
      const toItems = boxName === "box1" ? [...box1] : [...box2];
      const movingItem = fromItems.find((i) => i.productId === selectedId);
      fromSetter(fromItems.filter((i) => i.productId !== selectedId));
      toSetter([...toItems, movingItem]);
    }

    setSelectedCard(null);
  };

  // Card component
  const Card = ({ item, boxName }) => (
    <div
      id={item.productId}
      style={{
        padding: "12px",
        borderRadius: "6px",
        background: item.color,
        color: getContrastColor(item.color),
        cursor: "grab",
        border:
          selectedCard?.id === item.productId ? "3px solid yellow" : "none",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontWeight: "bold",
        height: "100px",
        textAlign: "center",
      }}
      draggable
      onDragStart={(e) => e.dataTransfer.setData("text/plain", item.productId)}
      onClick={() => handleCardClick(item.productId, boxName)}
    >
      {item.title}
    </div>
  );

  const handleDrop = (e, boxName) => {
    e.preventDefault();
    const id = e.dataTransfer.getData("text");
    if (!id) return;

    const fromBox = box1.some((i) => i.productId == id) ? "box1" : "box2";
    if (fromBox === boxName) return;

    const movingItem =
      fromBox === "box1"
        ? box1.find((i) => i.productId == id)
        : box2.find((i) => i.productId == id);

    if (fromBox === "box1") {
      setBox1(box1.filter((i) => i.productId != id));
      setBox2([...box2, movingItem]);
    } else {
      setBox2(box2.filter((i) => i.productId != id));
      setBox1([...box1, movingItem]);
    }
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        padding: "20px",
        gap: "20px",
      }}
    >
      <div style={{ display: "flex", justifyContent: "flex-end" }}>
        <button
          style={{
            padding: "10px 20px",
            backgroundColor: "#1976d2",
            color: "white",
            border: "none",
            borderRadius: "6px",
            cursor: "pointer",
          }}
          onClick={saveLayoutToAPI}
        >
          บันทึก
        </button>
      </div>

      <div style={{ display: "flex", gap: "20px" }}>
        <div
          style={{
            width: "150px",
            display: "flex",
            flexDirection: "column",
            gap: "10px",
          }}
        >
          {categories.map((cat) => (
            <button
              key={cat.id}
              style={{
                padding: "10px",
                background: selectedCategory === cat.id ? "#1976d2" : "#eeeeee",
                color: selectedCategory === cat.id ? "white" : "black",
                border: "none",
                borderRadius: "6px",
                cursor: "pointer",
              }}
              onClick={() => setSelectedCategory(cat.id)}
            >
              {cat.name}
            </button>
          ))}
        </div>

        <div
          id="box1"
          onDragOver={(e) => e.preventDefault()}
          onDrop={(e) => handleDrop(e, "box1")}
          style={{
            flex: 1,
            display: "grid",
            gridTemplateColumns: "repeat(4, 1fr)",
            gap: "10px",
            padding: "16px",
            background: "#f0f0f0",
            minHeight: "200px",
          }}
        >
          {filteredBox1.map((item) => (
            <Card key={item.productId} item={item} boxName="box1" />
          ))}
        </div>

        <div
          id="box2"
          onDragOver={(e) => e.preventDefault()}
          onDrop={(e) => handleDrop(e, "box2")}
          style={{
            flex: 0.3,
            display: "grid",
            gridTemplateColumns: "repeat(2, 1fr)",
            gap: "10px",
            padding: "16px",
            background: "#e0e0e0",
            minHeight: "200px",
          }}
        >
          {box2.map((item) => (
            <Card key={item.productId} item={item} boxName="box2" />
          ))}
        </div>
      </div>
    </div>
  );
}
